<template>
    <div class="month-detail-dialog" id="mcq_detail_dialog">
        <center>
            <h4 style="font-size:14px;font-weight:bold">建筑施工安全生产标准化工程项目月自评情况汇总表</h4>
        </center>
        <div v-loading="info_loading">
            <table :element-loading-text="info_loading_text" align="center" border="0" style="width:100%"
                   class="form_table form">
                <tbody>
                <tr>
                    <td class="form_label">
                        <label style="color: red;">*</label>项目名称
                    </td>
                    <td colspan="5">
                        <template v-if="isEdit">
                            <input v-model="detail_init.proname" v-validate="'required'"
                                   :class="{'is-danger':errors.has('proname')}" name="proname" style="width:90%">
                            <span v-if="errors.has('proname')"
                                  class="tip is-danger">{{errors.collect('proname')[0]}}</span>
                        </template>
                        <span v-else name="proname" style="width:90%">{{detail_init.proname}}</span>
                    </td>
                </tr>
                <tr>
                    <td class="form_label">
                        <label style="color: red;">*</label>检查日期
                    </td>
                    <td colspan="1" class="form-el-date-icon">
                        <template v-if="isEdit">
                            <input v-model="detail_init.checkdate" v-validate="'required|isDate'"
                                   :class="{'is-danger':errors.has('checkdate')}" name="checkdate">
                            <el-date-picker @change="parseDate_check" v-model="checkdate_el"
                                            :clearable="false"></el-date-picker>
                            <span v-if="errors.has('checkdate')" class="tip is-danger">{{errors.collect('checkdate')[0]}}</span>
                        </template>
                        <span v-else name="checkdate">{{detail_init.checkdate}}</span>
                    </td>
                    <td class="form_label">
                        <label style="color: red;">*</label>施工单位项目负责人
                    </td>
                    <td colspan="1">
                        <template v-if="isEdit">
                            <input v-model="detail_init.sgdwxmfzr" v-validate="'required'"
                                   :class="{'is-danger':errors.has('sgdwxmfzr')}" name="sgdwxmfzr">
                            <span v-if="errors.has('sgdwxmfzr')" class="tip is-danger">{{errors.collect('sgdwxmfzr')[0]}}</span>
                        </template>
                        <span v-else name="sgdwxmfzr">{{detail_init.sgdwxmfzr}}</span>
                    </td>
                    <td class="form_label">
                        <label style="color: red;">*</label>资格证书号码
                    </td>
                    <td colspan="1">
                        <template v-if="isEdit">
                            <input v-model="detail_init.sgdwxmfzrzsh" v-validate="'required'"
                                   :class="{'is-danger':errors.has('xmjlmc')}" name="sgdwxmfzrzsh">
                            <span v-if="errors.has('sgdwxmfzrzsh')"
                                  class="tip is-danger">{{errors.collect('sgdwxmfzrzsh')[0]}}</span>
                        </template>
                        <span v-else name="sgdwxmfzrzsh">{{detail_init.sgdwxmfzrzsh}}</span>
                    </td>
                </tr>
                <tr>
                    <td class="form_label">
                        <label style="color: red;">*</label>自评意见
                    </td>
                    <td colspan="5">
                        <template v-if="isEdit">
                            <textarea v-model="detail_init.evalidea" v-validate="'required'"
                                      :class="{'is-danger':errors.has('evalidea')}" name="evalidea" cols="90"
                                      rows="6"></textarea>
                            <span v-if="errors.has('evalidea')"
                                  class="tip is-danger">{{errors.collect('evalidea')[0]}}</span>
                        </template>
                        <textarea name="evalidea" v-else v-model="detail_init.evalidea" cols="90" rows="6"
                                  readonly></textarea>
                    </td>
                </tr>
                <!-- 建设单位 -->
                <template v-if="isjsdwchange !='0'">
                    <tr>
                        <td class="form_label">
                            建设单位
                        </td>
                        <td colspan="3">
                            <template v-if="isEdit">
                                <input v-model="detail_init.jsdwmc" v-validate="'required'"
                                       :class="{'is-danger':errors.has('jsdwmc')}" name="jsdwmc" style="width:98%">
                                <span v-if="errors.has('jsdwmc')"
                                      class="tip is-danger">{{errors.collect('jsdwmc')[0]}}</span>
                            </template>
                            <span v-else name="jsdwmc">{{detail_init.jsdwmc}}</span>
                        </td>
                        <td class="form_label">
                            项目负责人
                        </td>
                        <td colspan="1">
                            <template v-if="isEdit">
                                <input v-model="detail_init.jsdwxmfzr" v-validate="'required'"
                                       :class="{'is-danger':errors.has('jsdwxmfzr')}" name="jsdwxmfzr">
                                <span v-if="errors.has('jsdwxmfzr')"
                                      class="tip is-danger">{{errors.collect('jsdwxmfzr')[0]}}</span>
                            </template>
                            <span v-else name="jsdwxmfzr">{{detail_init.jsdwxmfzr}}</span>
                        </td>
                    </tr>
                </template>
                <template v-if="isjsdwchange =='0'">
                    <tr>
                        <td class="form_label">
                            请选择建设单位
                        </td>
                        <td colspan="5">
                            <table style="width:100%">
                                <tr>
                                    <th align="center">
                                        选择
                                    </th>
                                    <th style="width:50%">
                                        项目负责人姓名
                                    </th>
                                    <th style="width:20%">
                                        总监姓名
                                    </th>
                                    <th style="width:25%">
                                        项目负责人身份证号
                                    </th>
                                </tr>
                                <tr v-for="(val , index ) in jsdwList " :key="index">
                                    <td align="center">
                                        <input type="radio" :value="val.unitId" v-model="jsSeclectId"
                                               @change="getJS($event ,val)">
                                    </td>
                                    <td>
                                        {{val.unitName}}
                                    </td>
                                    <td>
                                        {{val.person_name}}
                                    </td>
                                    <td>
                                        {{val.person_identity}}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </template>
                <tr v-if="detail_init.opState>='15'">
                    <td class="form_label">
                        <label style="color: red;">*</label>建设单位负责人意见
                    </td>
                    <td colspan="2">
                        <span name="jsdwidea">{{detail_init.jsdwidea}}</span>
                    </td>
                    <td class="form_label">
                        是否合格
                    </td>
                    <td colspan="2">
                        <input type="radio" value="1" v-model="detail_init.isUnitPersonQualified" id="1" disabled>
                        <label for="1">合格</label>&nbsp;&nbsp;&nbsp;
                        <input type="radio" value="0" v-model="detail_init.isUnitPersonQualified" id="0" disabled>
                        <label for="0">不合格</label>
                    </td>
                </tr>

                <!-- 监理单位 -->
                <template v-if="isjldwchange !='0'">
                    <tr>
                        <td class="form_label">
                            监理单位
                        </td>
                        <td colspan="3">
                            <template v-if="isEdit">
                                <input v-model="detail_init.jldwmc" name="jldwmc" style="width:98%">
                            </template>
                            <span v-else name="jldwmc">{{detail_init.jldwmc}}</span>
                        </td>
                        <td class="form_label">
                            总监理工程师
                        </td>
                        <td colspan="1">
                            <template v-if="isEdit">
                                <input v-model="detail_init.jldwgcsmc" name="jldwgcsmc">
                            </template>
                            <span v-else name="jldwgcsmc">{{detail_init.jldwgcsmc}}</span>
                        </td>
                    </tr>
                </template>
                <template v-if="isjldwchange =='0'">
                    <tr>
                        <td class="form_label">
                            请选择监理单位
                        </td>
                        <td colspan="5">
                            <table style="width:100%">
                                <tr>
                                    <th align="center">
                                        选择
                                    </th>
                                    <th style="width:50%">
                                        监理单位
                                    </th>
                                    <th style="width:20%">
                                        总监姓名
                                    </th>
                                    <th style="width:25%">
                                        总监身份证号
                                    </th>
                                </tr>
                                <tr v-for="(val , index ) in jldwList " :key="index">
                                    <td align="center">
                                        <input type="radio" :value="val.unitId" v-model="jlSeclectId"
                                               @change="getJL($event , val)">
                                    </td>
                                    <td>
                                        {{val.unitName}}
                                    </td>
                                    <td>
                                        {{val.person_name}}
                                    </td>
                                    <td>
                                        {{val.person_identity}}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </template>
                <tr v-if="detail_init.opState>='15'">
                    <td class="form_label">
                        总监意见
                    </td>
                    <td colspan="2">
                        <span name="jldwidea">{{detail_init.jldwidea}}</span>
                    </td>
                    <td class="form_label">
                        是否合格
                    </td>
                    <td colspan="2">
                        <input type="radio" value="1" v-model="detail_init.isSEQualified" id="1" disabled>
                        <label for="1">合格</label>&nbsp;&nbsp;&nbsp;
                        <input type="radio" value="0" v-model="detail_init.isSEQualified" id="0" disabled>
                        <label for="0">不合格</label>
                    </td>
                </tr>
                <tr>
                    <td class="form_label">
                        自评分数
                    </td>
                    <td colspan="2">
                        <template v-if="isEdit">
                            <input v-model="detail_init.evalgrade" :class="{'is-danger':errors.has('evalgrade')}"
                                   name="evalgrade">
                            <span v-if="errors.has('evalgrade')" class="tip is-danger">{{errors.collect('evalgrade')[0]}}</span>
                        </template>
                        <span v-else name="evalgrade">{{detail_init.evalgrade}}</span>
                    </td>
                    <td class="form_label">
                        <label style="color: red;">*</label>自评结果
                    </td>
                    <td colspan="2">
                        <template v-if="isEdit">
                            <select v-if="chk" v-model="detail_init.evalresult" name="evalresult" filter="false">
                                <option value="优良">优良</option>
                                <option value="合格">合格</option>
                                <option value="不合格">不合格</option>
                            </select>
                            <select v-else v-validate="'required'" v-model="detail_init.evalresult" name="evalresult"
                                    filter="false">
                                <option value="优良">优良</option>
                                <option value="合格">合格</option>
                                <option value="不合格">不合格</option>
                            </select>
                            <input type="checkbox" v-model="chk" id="chk">
                            <label for="chk">自动计算分数和结果</label>
                            <span v-if="errors.has('evalresult')"
                                  class="tip is-danger">{{errors.collect('evalresult')[0]}}</span>
                        </template>
                        <span v-else name="evalresult">{{detail_init.evalresult}}</span>
                    </td>
                </tr>
                <tr v-if="roleId == 'UnitPerson' ||roleId == 'SE'">
                    <td class="form_label">年份</td>
                    <td>
                        <span name="curyear">{{detail_init.curyear}}</span>
                    </td>
                    <td class="form_label">月份</td>
                    <td>
                        <span name="curmonth">{{detail_init.curmonth}}</span>
                    </td>
                </tr>
                <!-- <tr>
                    <td class="form_label">存在问题</td>
                    <td colspan="2">
                        <template v-if="isEdit">
                            <input style="width:100%" v-model="detail_init.existproblem" name="existproblem">
                        </template>
                        <span v-else name="existproblem" style="width:100%">{{detail_init.existproblem}}</span>
                    </td>
                    <td class="form_label">整改情况</td>
                    <td colspan="2">
                        <template v-if="isEdit">
                            <input style="width:100%" v-model="detail_init.changesituation" name="changesituation">
                        </template>
                        <span v-else name="changesituation" style="width:100%">{{detail_init.changesituation}}</span>
                    </td>
                </tr> -->
                </tbody>
            </table>
            <div style=" width: 100%;    overflow: auto;">
                <detail-dialog-table ref="table" :isEdit="isEdit" v-loading="table_loading"
                                     :element-loading-text="table_loading_text"
                                     @passcurrentRow="(val)=>{currentRow=val[0].currentRow}"
                                     @attachOperate="attachOperate" :tableData="tableData"></detail-dialog-table>
            </div>
        </div>
        <sec-sign ref="secSign" @closeSecSeal="closeSecSeal" @uploadcomplete="uploadcomplete" v-if="showSecSign"
                  rpx="hy_safety_projectmontheval" :id="detail_init.id" :isView="false"
                  :uploadInfo="{controllName:'safetyProjectMonthEval' ,method:'updateAttachFileInfo'}"
                  :sealInfo="{controllName:'safetyProjectMonthEval' , method:'sealAndSubmit' ,params:sealParams}"></sec-sign>
    </div>
</template>
<script>
    import {monthCheckQuery} from "@/assets/json.js"
    import {API_SecSeal, API_ProjectCheck} from "@/api/api.js"
    import JS_secSeal from "@/tool/secSeal.js" //签章JS
    import secSign from "@/components/common/showSecSign.vue"
    import ocx from "@/components/common/ocx.vue"
    import getBrowser from "@/tool/getBrowser.js";
    import {parse_date} from "@/tool/parse.js"
    import {hy_safetyProjectMonthEval} from "@/entity/hy_safetyProjectMonthEval.js"
    //项目详情
    import detailDialogTable from "./detail_dialog_table.vue"

    export default {
        props: ["proInfo", "isEdit"],
        computed: {
            canshowOCX() {
                return this.showOCX && this.isIE;
            }
        },
        mounted() {
            if (this.isEdit) {
                this.title = "编辑";
            }
            else
                this.title = "查看详情";
            this.queryAll();
        },
        data() {
            return {
                showOCX: false,
                isIE: getBrowser().ie,
                title: "查看详情",
                detail_init: hy_safetyProjectMonthEval,
                tableData: [],//下方表格的数据
                // showBtn: { attachDetail: true, attachUpload: false, queryDetail: false },
                info_loading: true,
                table_loading: false,
                info_loading_text: "",
                table_loading_text: "",
                checkdate_el: "",
                chk: true,//自动计算分数和结果
                roleId: JSON.parse(localStorage.userinfo).roleId,
                // 监理
                jldwList: [],
                isjldwchange: "0", //是
                jlSeclectId: "",
                JSUnit: {},
                // 建设
                jsdwList: [],
                isjsdwchange: "0", //是
                jsSeclectId: "",
                JLUnit: {},
                mainList: [],//存在问题和解决方法的暂时list
                // 签章
                showSecSign: false,
                sealParams: {}
            }
        },
        methods: {
            getJS(evt, pojo) {
                // 建设radio选中后
                if (evt.target.checked) {
                    this.JSUnit = pojo;
                }
            },
            getJL(evt, pojo) {
                if (evt.target.checked) {
                    this.JLUnit = pojo;
                }
            },
            uploadcomplete() {
                // console.log("get uploadcomplete")
                if (this.isIE) {
                    this.showOCX = false;
                    this.$emit("showDialogOCX", false)
                } else {
                    this.showSecSign = null;
                }
                this.$parent.$parent.showBtns = true;
                this.$parent.$parent.closeDialog();
            },
            closeSecSeal(res) {
                // console.log("get closeSecSeal")
                if (res.op == "close" || res.success == false) {
                    this.tableData.push(this.mainList[0])
                    this.tableData.push(this.mainList[1])//加上整改情况和主要问题
                    if (this.roleId == "pm") {
                        API_SecSeal.deletePdf({
                            data: {
                                recordId: this.detail_init.id,
                                code: "SGXMKP010",
                                tableName: "hy_safety_projectmontheval",
                                rpx: "safetyprojectmontheval"
                            }
                        }).then(res => {
                            this.info_loading = false;
                            if (this.isIE) {
                                this.showOCX = false;
                                this.$emit("showDialogOCX", false)
                            } else {
                                this.showSecSign = null;
                            }
                            this.$parent.$parent.showBtns = true;
                        })
                    } else {
                        this.info_loading = false;
                        if (this.isIE) {
                            this.showOCX = false;
                            this.$emit("showDialogOCX", false)
                        } else {
                            this.showSecSign = null;
                        }
                        this.$parent.$parent.showBtns = true;
                    }
                }
            },
            attachOperate(obj) {//三个附件按钮的操作
                this.$emit("attachOperate", obj)
            },
            getFiles(fileList) {//获取上传的附件

            },
            queryAll() {
                this.info_loading = true;
                this.table_loading = true;
                this.info_loading_text = "加载中，请稍候";
                API_ProjectCheck.getMonthOthDetail({data: this.proInfo.id}).then(res => {
                    this.detail_init = res.tSafetyProjectMonthEval;
                    this.isjldwchange = res.isjldwchange;
                    if (res.isjldwchange == "0") {
                        this.jldwList = res.jldwList;
                    }
                    this.isjsdwchange = res.isjsdwchange;
                    if (res.isjsdwchange == "0") {
                        this.jsdwList = res.jsdwList;
                    }

                    this.detail_init.checkdate = parse_date(this.detail_init.checkdate);
                    this.info_loading = false;
                    res.tSafetyProjectMonthEval.safetyProjectMonthEvalDetails.forEach(v => {
                        this.tableData.push(v)
                    })

                    // 存在问题和解决方案的栏位
                    if (res.tSafetyProjectMonthEval.safetyProjectMonthEvalDetails.length > 0) {
                        this.setProblems(this.detail_init);
                        this.tableData.push(Object.assign({}, detailsPojo))
                        this.setChanges(this.detail_init);
                        this.tableData.push(Object.assign({}, detailsPojo))
                        detailsPojo = Object.assign({}, detailsPojo)
                    }

                    this.table_loading = false;
                    this.$emit("passId", this.detail_init.id)
                })
            },
            doSave(status) {
                if (status == 'seal') {
                    this.$validator.validateAll().then(res => {
                        if (!res) {
                            this.$emit("showBtns");
                            return
                        }
                    })
                }
                if (!this.chk) {
                    if (!this.detail_init.evalresult || this.detail_init.evalresult == "") {
                        this.$alert('自评结果为必填项', '', {confirmButtonText: '确定', type: "warning",});
                        this.$emit("showBtns")
                        return false;
                    }
                }
                let me = this;
                this.$confirm("您确定要保存吗？", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: "warning"
                }).then(() => {
                    if (me.detail_init.issgdwsign == "1") {
                        me.$confirm("该检查表已盖章，您确认要删除原有文书，重新生成吗？", "提示", {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消', type: "warning"
                        }).then(() => {
                            this.$parent.$parent.showBtns = false;
                            me.saveStep(status);
                        })
                    } else {
                        this.$parent.$parent.showBtns = false;
                        me.saveStep(status);
                    }
                }).catch(() => {
                });
            },
            saveStep(status) {
                let me = this;
                me.info_loading = true;
                let obj = me.caculate(0, 0, me.detail_init.safetyProjectMonthEvalDetails,status)//计算表格每一行分数
                if (this.isjsdwchange == "0") {
                    if (this.JSUnit == {}) {
                        this.$alert('请选择建设单位！', '', {confirmButtonText: '确定', type: "warning",});
                        this.$emit("showBtns")
                        me.info_loading = false;
                    } else {
                        this.detail_init.jsdwid = this.JSUnit.unitId;
                        this.detail_init.jsdwmc = this.JSUnit.unitName;
                        this.detail_init.jsdwxmfzrcard = this.JSUnit.person_identity;
                        this.detail_init.jsdwxmfzr = this.JSUnit.person_name;
                    }
                }
                if (this.isjldwchange == "0") {
                    if (this.JLUnit == {}) {
                        this.$alert('请选择监理单位！', '', {confirmButtonText: '确定', type: "warning",});
                        this.$emit("showBtns")
                        me.info_loading = false;
                    } else {
                        this.detail_init.jldwid = this.JLUnit.unitId;
                        this.detail_init.jldwmc = this.JLUnit.unitName;
                        this.detail_init.jldwgcscard = this.JLUnit.person_identity;
                        this.detail_init.jldwgcsmc = this.JLUnit.person_name;
                    }
                }
                if (typeof obj == 'boolean' && obj == false) {
                    this.$emit("showBtns")
                    me.info_loading = false;
                    return false;
                }
                let allhz = obj.allhz;
                let allnum = obj.allnum;
                if (me.chk) {//自动计算分数和结果
                    if (me.chk) {
                        if (allnum > 0) {
                            allhz = allhz / allnum;
                        }
                        allhz = allhz.toFixed(2);
                        me.detail_init.evalgrade = allhz
                    }
                    if (me.chk) {
                        if (allhz >= 80) {
                            me.detail_init.evalresult = "优良";
                        } else if (allhz >= 70 && allhz < 80) {
                            me.detail_init.evalresult = "合格";
                        } else {
                            me.detail_init.evalresult = "不合格";
                        }
                    }
                }
                // 将整改情况和解决方法set到主表
                // 存在问题和整改情况的set和至少要填写一格
                let len = this.tableData.length;
                let changes = this.tableData[len - 1], cF = false, cI = 1;
                let problems = this.tableData[len - 2], pF = false, pI = 1;
                for (let name in problems) {
                    if (name.startsWith("xmgaint")) {
                        this.detail_init['existproblem' + pI] = problems[name];
                        if (problems[name] != null && problems[name].trim() != "") {
                            pF = true;//至少填写一格
                        }
                        pI++;
                    }
                }
                for (let name in changes) {
                    if (name.startsWith("xmgaint")) {
                        this.detail_init['changesituation' + cI] = changes[name];
                        if (changes[name] != null && changes[name].trim() != "") {
                            cF = true;//至少填写一格
                        }
                        cI++;
                    }
                }
                if (status == 'seal' && (!cF || !pF)) {
                    this.$alert('请填写现场存在问题与整改情况。', '', {confirmButtonText: '确定', type: "warning",});
                    this.$emit("showBtns")
                    this.info_loading = false;
                    return false;
                }
                // 保存动作
                me.info_loading = true;
                // 抽出最后两行的整改情况和问题
                this.mainList = this.tableData.splice(this.tableData.length - 2, 2);
                if (status == 'save') {
                    API_ProjectCheck.updateMonth({data: me.detail_init}).then(res => {
                        this.info_loading = false;
                        this.$parent.$parent.showBtns = true;
                        if (res.success) {
                            this.$notify({
                                message: "保存成功",
                                type: "success",
                                offset: document.body.clientHeight - 200, duration: 2000
                            });
                            this.$emit("closeDialog")
                        } else {
                            this.$alert(res.msg, "保存失败", {
                                confirmButtonText: "确定",
                                type: "error"
                            })
                            this.tableData.push(this.mainList[0])
                            this.tableData.push(this.mainList[1])//加上整改情况和主要问题
                        }
                    })
                } else if (status == 'seal') {
                    // 盖章并保存
                    this.$parent.$parent.showBtns = false;
                    me.sealParams = {data: me.detail_init};
                    me.info_loading = false;
                    //console.log(me.isIE)
                    if (me.isIE) {
                        me.showOCX = true;
                        this.$emit("showDialogOCX", true, me.sealParams, this.detail_init.id)
                    } else {
                        me.showSecSign = true;
                    }
                    me.$emit('openReflash')
                }
            },
            queryESign(isViewSeal) {
                JS_secSeal.onload(this, isViewSeal);
                API_SecSeal.getList("20/1/", {
                    limit: {
                        recordId: this.detail_init.id,
                        code: "SGXMKP010",
                        tableName: "hy_safety_projectmontheval"
                    }
                }).then(res => {
                    if (res.total > 0) {
                        JS_secSeal.viewSeal(res.data[0].filepath, (res.data[0].type ? res.data[0].type === "getFromSupervisorEnd" : false), isViewSeal);
                    } else {
                        this.$notify({
                            message: "无可展示的签章文件，请先盖章保存。",
                            type: "info",
                            offset: document.body.clientHeight - 200, duration: 2000
                        });
                    }
                })
            },
            parseDate_check(val) {
                this.detail_init['checkdate'] = val;
                this.$nextTick(function () {
                    this.$validator.validate("checkdate");
                })
            },
            caculate(allhz, allnum, list, status) {
                for (let i = 0; i < list.length; i++) {
                    if (list[i].progress == "undefined" || list[i].progress == undefined) {
                        list[i].progress.progress = "";
                    }
                    if (list[i].progressmx == "undefined" || list[i].progressmx == undefined) {
                        list[i].progressmx = "";
                    }
                    if (status == 'seal') {
                        if (list[i].progress == null || list[i].progress == "") {
                            this.$alert("请填写所有单位工程的形象进度", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if ((list[i].progress != '6' && list[i].progress != '5') && (list[i].progressmx == null || list[i].progressmx.trim() == "")) {
                            this.$alert("非“未开工”或“完工”状态的单位工程，请填写“详细进度”", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                    }
                    var hz = 0;
                    var hzm = 0;
                    if (list[i]["xmgaint1"] != null && list[i]["xmgaint1"] != "") {
                        if (isNaN(list[i]["xmgaint1"])) {
                            this.$alert("安全管理填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint1"]) > 10) {
                            this.$alert("安全管理填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = 10;
                        hz = list[i]["xmgaint1"] / 1;
                    }
                    if (list[i]["xmgaint2"] != null && list[i]["xmgaint2"] != "") {
                        if (isNaN(list[i]["xmgaint2"])) {
                            this.$alert("文明施工填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint2"]) > 15) {
                            this.$alert("文明施工填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = hzm + 15;
                        hz = hz + list[i]["xmgaint2"] / 1;
                    }
                    if (list[i]["xmgaint3"] != null && list[i]["xmgaint3"] != "") {
                        if (isNaN(list[i]["xmgaint3"])) {
                            this.$alert("脚手架填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint3"]) > 10) {
                            this.$alert("脚手架填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = hzm + 10;
                        hz = hz + list[i]["xmgaint3"] / 1;
                    }
                    if (list[i]["xmgaint4"] != null && list[i]["xmgaint4"] != "") {
                        if (isNaN(list[i]["xmgaint4"])) {
                            this.$alert("基坑工程填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint4"]) > 10) {
                            this.$alert("基坑工程填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = hzm + 10;
                        hz = hz + list[i]["xmgaint4"] / 1;
                    }
                    if (list[i]["xmgaint5"] != null && list[i]["xmgaint5"] != "") {
                        if (isNaN(list[i]["xmgaint5"])) {
                            this.$alert("模板支架填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint5"]) > 10) {
                            this.$alert("模板支架填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = hzm + 10;
                        hz = hz + list[i]["xmgaint5"] / 1;
                    }
                    if (list[i]["xmgaint6"] != null && list[i]["xmgaint6"] != "") {
                        if (isNaN(list[i]["xmgaint6"])) {
                            this.$alert("高处作业填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint6"]) > 10) {
                            this.$alert("高处作业填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = hzm + 10;
                        hz = hz + list[i]["xmgaint6"] / 1;
                    }
                    if (list[i]["xmgaint7"] != null && list[i]["xmgaint7"] != "") {
                        if (isNaN(list[i]["xmgaint7"])) {
                            this.$alert("施工用电填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint7"]) > 10) {
                            this.$alert("施工用电填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = hzm + 10;
                        hz = hz + list[i]["xmgaint7"] / 1;
                    }
                    if (list[i]["xmgaint8"] != null && list[i]["xmgaint8"] != "") {
                        if (isNaN(list[i]["xmgaint8"])) {
                            this.$alert("物料提升机与施工升降机填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint8"]) > 10) {
                            this.$alert("物料提升机与施工升降机填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = hzm + 10;
                        hz = hz + list[i]["xmgaint8"] / 1;
                    }
                    if (list[i]["xmgaint9"] != null && list[i]["xmgaint9"] != "") {
                        if (isNaN(list[i]["xmgaint9"])) {
                            this.$alert("塔式起重机与起重吊装填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint9"]) > 10) {
                            this.$alert("塔式起重机与起重吊装填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = hzm + 10;
                        hz = hz + list[i]["xmgaint9"] / 1;
                    }
                    if (list[i]["xmgaint10"] != null && list[i]["xmgaint10"] != "") {
                        if (isNaN(list[i]["xmgaint10"])) {
                            this.$alert("施工机具填写错误！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        if (Number(list[i]["xmgaint10"]) > 5) {
                            this.$alert("施工机具填写分值超过规定分值！", '', {confirmButtonText: '确定', type: "warning",});
                            this.info_loading = false;
                            return false;
                        }
                        hzm = hzm + 5;
                        hz = hz + list[i]["xmgaint10"] / 1;
                    }
                    // if (hzm > 0) {
                    // 	if (list[i].progress == null || list[i].progress == "") {
                    // 		this.$alert("第" + parseInt(i + 1) + "行有录入评价分，请选择形象进度!", '', { confirmButtonText: '确定', type: "warning", });
                    // 		this.info_loading = false;
                    // 		return false;
                    // 	}
                    // 	if ((list[i].progress !='6'&& list[i].progress !='5') && (list[i].progressmx == null || list[i].progressmx.trim() == "")) {
                    // 		this.$alert("除“未开工”或“完工”状态的单位工程，均要填写", '', { confirmButtonText: '确定', type: "warning", });
                    // 		this.info_loading = false;
                    // 		return false;
                    // 	}
                    // }
                    if (hzm < 100) {
                        hz = (hz / hzm * 100).toFixed(2);
                    }
                    // console.log("hz="+hz)
                    if (hz > 0) {
                        list[i]["hzgaint"] = hz;
                        allhz = allhz / 1 + hz / 1;
                        allnum = allnum + 1;
                    } else {
                        // list[i]["hzgaint"] = 0;
                        list[i]["hzgaint"] = null;
                    }
                    if (list[i].itemid == "" || list[i].itemid == null) {
                        list[i].datasource = "自行添加";
                    } else {
                        list[i].datasource = "系统导入";
                    }
                }
                return {allhz: allhz, allnum: allnum}
            },
            setProblems(pojo) {
                detailsPojo.xmgaint1 = pojo.existproblem1;
                detailsPojo.xmgaint2 = pojo.existproblem2;
                detailsPojo.xmgaint3 = pojo.existproblem3;
                detailsPojo.xmgaint4 = pojo.existproblem4;
                detailsPojo.xmgaint5 = pojo.existproblem5;
                detailsPojo.xmgaint6 = pojo.existproblem6;
                detailsPojo.xmgaint7 = pojo.existproblem7;
                detailsPojo.xmgaint8 = pojo.existproblem8;
                detailsPojo.xmgaint9 = pojo.existproblem9;
                detailsPojo.xmgaint10 = pojo.existproblem10;
            },
            setChanges(pojo) {
                detailsPojo.xmgaint1 = pojo.changesituation1;
                detailsPojo.xmgaint2 = pojo.changesituation2;
                detailsPojo.xmgaint3 = pojo.changesituation3;
                detailsPojo.xmgaint4 = pojo.changesituation4;
                detailsPojo.xmgaint5 = pojo.changesituation5;
                detailsPojo.xmgaint6 = pojo.changesituation6;
                detailsPojo.xmgaint7 = pojo.changesituation7;
                detailsPojo.xmgaint8 = pojo.changesituation8;
                detailsPojo.xmgaint9 = pojo.changesituation9;
                detailsPojo.xmgaint10 = pojo.changesituation10;
            }
        },
        components: {detailDialogTable, secSign}
    }
    let detailsPojo = {
        "id": null,
        "monthevalid": "",
        "conunitid": "",
        "proid": "",
        "curyear": 0,
        "curmonth": 0,
        "itemid": "",
        "itemname": "",
        "archArea": 0,
        "structType": "",
        "hzgaint": 0,
        "xmgaint1": "",
        "xmgaint2": "",
        "xmgaint3": "",
        "xmgaint4": "",
        "xmgaint5": "",
        "xmgaint6": "",
        "xmgaint7": "",
        "xmgaint8": "",
        "xmgaint9": "",
        "xmgaint10": "",
        "datasource": "",
        "delFlag": 0,
        "progress": "",
        "progressmx": "",
        "synTimestamp": ""
    }
</script>
<style>
    .month-detail-dialog .el-dialog.el-dialog--large {
        overflow-y: scroll;
        height: 60%;
        min-width: 900px;
        overflow: auto;
    }

    .month-detail-dialog .base-table {
        width: 3000px;
        min-height: 200px;
        margin-top: 10px;
    }

    .month-detail-dialog .el-dialog.el-dialog--large {
        min-height: 450px;
        overflow: initial;
    }

    .month-detail-dialog input,
    .month-detail-dialog textarea {
        border: inherit;
        border-color: #a9a9a9;
        padding-left: 3px;
    }

    .month-detail-dialog .footer-btn-group .btn {
        padding: 2px 10px;
    }

    .month-detail-dialog .form_label {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// detail_dialog.vue?79fa22f0